import React from "react";
import { IFormikFieldProps } from "../../interfaces/formik/IFormikField";
import { getCurrencyFormat } from "../../utils/index.ts";

const InputEditProfile = ({
  sm = 5,
  smLabel = 3,
  min = 0,
  max = 1000000,
  hidden = false,
  required = true,
  readonly = false,
  withIcon = false,
  autoFocus = false,
  type = "text",
  label = <></>,
  unclickable = false,
  tooltip = null,
  onChangeFile = (e: any) => {},
  money = false,
  button = null,
  numericOnly = false,
  ...props
}: IFormikFieldProps & {
  onChangeFile?: (e: any) => void;
  label: any;
  unclickable?: boolean;
  money?: boolean;
  tooltip?: any;
  button?: React.ReactNode;
  numericOnly?: boolean;
  displayValue?: string;
}) => {
  const error =
    props.formik.touched[props.field] &&
    Boolean(props.formik.errors[props.field]);
  const unclickableObject = { pointerEvents: "none", cursor: "not-allowed" };

  return (
    <React.Fragment>
      <tr>
        <td className={`field`} style={{ color: `${error ? "red" : "black"}` }}>
          {label} :{" "}
        </td>
        <td className="d-flex flex-row align-items-center ">
          <div className={`col-md-${sm}`} style={unclickable ? {cursor: 'not-allowed'} : {}}>
            <input
              type={type}
              className={`form-control mb-5px fs-13px ${
                error ? "is-invalid" : ""
              }`}
              id={props.field}
              name={props.field}
              placeholder={props.placeholder}
              onChange={(event: any) => {
                if (type === "file") {
                  const file = event.target.files[0] as any;
                  onChangeFile(file);
                }

                if (type === "number") {
                  const parsed = parseInt(event.target.value);
                  const finalParsed = isNaN(parsed) ? 0 : parsed;

                  if (finalParsed < min) {
                    event.target.value = "0";
                  } else if (finalParsed > max) {
                    event.target.value = String(max);
                  }
                }

                // Validación para inputs de texto que solo aceptan números
                if (numericOnly && type === "text") {
                  const value = event.target.value;
                  // Solo permite números (elimina cualquier carácter que no sea dígito)
                  const numericValue = value.replace(/\D/g, '');
                  event.target.value = numericValue;
                }

                if (money) {
                  // console.log(event.target.value)
                  // event.target.value = getCurrencyFormat(event.target.value);
                }

                props.formik.handleChange(event);
              }}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  props.formik.handleSubmit();
                }

                // Prevenir la entrada de caracteres no numéricos en inputs numericOnly
                if (numericOnly && type === "text") {
                  const char = event.key;
                  // Permitir teclas de control (Backspace, Tab, Enter, etc.)
                  if (!/[0-9]/.test(char) && event.key.length === 1) {
                    event.preventDefault();
                  }
                }
              }}
              value={
                props.displayValue !== undefined
                  ? props.displayValue
                  : props.formik.values[props.field]
              }
              readOnly={readonly}
              disabled={props.disabled}
              style={unclickable ? {pointerEvents: 'none'} : {}}
            />
            <div
              className="invalid-feedback"
              style={{
                marginTop: "-1%",
                display: "flex",
                marginLeft: "0.25em",
              }}
            >
              {props.formik.touched[props.field] &&
                props.formik.errors[props.field] && (
                  <>{props.formik.errors[props.field]}</>
                )}
            </div>
          </div>
          {tooltip && (
            <div className="d-flex justify-content-center align-items-center">
              {tooltip}
            </div>
          )}
          {button && (
            <div className="d-flex justify-content-center align-items-center ms-2">
              {button}
            </div>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

export default InputEditProfile;